import * as React from 'react';

import { SVGProps } from '../../types';

export const IconCopyPasteQuestionsSvg = ({
  title,
  titleId,
  ...props
}: SVGProps) => (
  <svg
    width={36}
    height={36}
    viewBox="0 0 36 36"
    focusable="false"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}

    <rect x="4.75" y="3.75" width="17.5" height="21.5" rx="2" fill="#E4FBFF" />
    <rect
      x="17.75"
      y="14.75"
      width="17.5"
      height="21.5"
      rx="2"
      fill="#E4FBFF"
    />

    <path
      d="M31.249 12C32.767 12.0002 34 13.2307 34 14.75V32.25C34 33.7688 32.7688 35 31.25 35H17.75C16.2312 35 15 33.7688 15 32.25V14.75C15 13.2307 16.233 12.0002 17.751 12H31.249ZM17.751 13.5C17.0601 13.5002 16.5 14.0604 16.5 14.75V32.25C16.5 32.9404 17.0596 33.5 17.75 33.5H31.25C31.9404 33.5 32.5 32.9404 32.5 32.25V14.75C32.5 14.0604 31.9399 13.5002 31.249 13.5H17.751Z"
      fill="#0099C7"
    />
    <path
      d="M18.25 1C19.7688 1 21 2.23122 21 3.75V9.73828H19.5V3.75C19.5 3.05964 18.9404 2.5 18.25 2.5H4.75C4.05964 2.5 3.5 3.05964 3.5 3.75V21.25C3.5 21.9404 4.05964 22.5 4.75 22.5H13V24H4.75C3.23122 24 2 22.7688 2 21.25V3.75C2 2.23122 3.23122 1 4.75 1H18.25Z"
      fill="#0099C7"
    />

    <path
      d="M29.25 17.25H19.75"
      stroke="#0099C7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.25 20.25H19.75"
      stroke="#0099C7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.25 23.25H19.75"
      stroke="#0099C7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.75 6.75L16.25 6.75"
      stroke="#0099C7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.75 9.75L16.25 9.75"
      stroke="#0099C7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.75 12.75L11.25 12.75"
      stroke="#0099C7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
